// Helper method to wire a simple top-level component. This will do the following:
//  1. Register as new angular module
//  2. Add simple UI router State
//  3. Return reference to angular module
//
// TODO: consider expansion to nontrivial use cases:
// (extra module deps, sub-router-states, ...)

import angular from 'angular';
import uiRouter from 'angular-ui-router';

export default function wire(
  moduleName,
  template,
  controller,
  controllerName,
  url = null,
  resolve = null
) {
  // Unless a custom URL is specified, use the module name
  if (url == null) {
    url = `/${moduleName}`;
  }

  return angular
    .module(moduleName, [uiRouter])
    .controller(controllerName, controller)
    .config(($stateProvider) => {
      'ngInject';
      $stateProvider.state(moduleName, {
        url: url,
        resolve: resolve ? resolve : {},
        template: template,
        controller: controller,
        controllerAs: 'vm',
      });
    });
}



// WEBPACK FOOTER //
// ./app/pages/wire.js